import { Helmet } from 'react-helmet';
import Simdata5gorderDetail
  from 'src/components/simdata5gorder-detail/Simdata5gorderDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import Simdata5gorderListToolbar from '../components/simdata5gorder-detail/Simdata5gorderToolbar';

const Simdata5gorder = () => (
  <>
    <Helmet>
      <title>Quản lý đơn hàng sim data 5G</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Simdata5gorderListToolbar />
        <Box sx={{ pt: 3 }}>
          <Simdata5gorderDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Simdata5gorder;
